<!--
 * @Description: 页脚
-->
<template>
  <div class="footer">
    <div class="copyright">
      {{ copyright }}
    </div>
    <div class="basic_copyright_frame">
      <a
        class="copyright_a_href"
        rel="noopener noreferrer"
        href="https://beian.miit.gov.cn/"
        target="_blank"
      >{{ copyrightLinkName }}</a>
    </div>
    <div class="version">
      {{ version }}
    </div>
  </div>
</template>

<script>
import config from '@/../package.json'
import { useI18n } from 'vue-i18n'
export default {
  setup() {
    const { t } = useI18n()
    const copyright = config.copyright
    const version = '1.0.6.03260'// config.version
    const copyrightLinkName = '苏ICP备2023012889号-3'
    return {
      t,
      copyright,
      version,
      copyrightLinkName
    }
  }
}
</script>

<style lang="scss" scoped>
.footer {
  height: 30px;
  margin-top: -30px;
  overflow: hidden;
  position: relative;
  background: #fff;
  color: #909399;
  z-index: 1002;
  box-shadow: 0 1px 4px rgba(0, 21, 41, 0.08);
  padding: 5px 30px;
}
.copyright {
  float: left;
}
.basic_copyright_frame {
  margin-left: 10px;
  float: left;
  line-height:22px;
  font-size: 13px;
}
.version {
  float: right;
}
.copyright_a_href {
  color: #657180;
  cursor: pointer;
}
</style>
